module.exports = __webpack_public_path__ + "img/accuracy.60ca789b.svg";